import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import jobpositionApi from 'api/jobpositionApi'

export const thunkJobposition = createAsyncThunk(
  'jobposition/getAll',
  async (param, thunkApi) => {
    try {
      const res = await jobpositionApi.getAll(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
export const thunkFindJobposition = createAsyncThunk(
  'job-position/find',
  async (body, thunkApi) => {
    try {
      const res = await jobpositionApi.find(body)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
export const thunkSaveJobposition = createAsyncThunk(
  'job-position/save',
  async (body, thunkApi) => {
    try {
      const res = await jobpositionApi.save(body)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
export const thunkfindByIdJobposition = createAsyncThunk(
  'job-position/findById',
  async (param, thunkApi) => {
    try {
      const res = await jobpositionApi.findById(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
export const thunkRemoveJobposition = createAsyncThunk(
  'job-position/remove',
  async (param, thunkApi) => {
    try {
      const res = await jobpositionApi.remove(param)
      return res // Trả về dữ liệu API trả về
    } catch (error) {
      return thunkApi.rejectWithValue(error) // Xử lý lỗi
    }
  },
)
const reportSlice = createSlice({
  name: 'jobposition',
  initialState: {
    processes: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunkJobposition.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(thunkJobposition.fulfilled, (state, action) => {
        state.loading = false
        state.processes = action.payload // Cập nhật state với dữ liệu trả về
      })
  },
})

const { reducer } = reportSlice
export default reducer
